import './swiper';
import './navmenu';
import './switcher';
